import { render, staticRenderFns } from "./DeliveryScheduleCalendar.vue?vue&type=template&id=0ffd2e78&"
import script from "./DeliveryScheduleCalendar.vue?vue&type=script&lang=js&"
export * from "./DeliveryScheduleCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryScheduleCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports